import { httpPatients } from "./http";

// DRF pagination safe
const normalize = (data) => (Array.isArray(data) ? data : data?.results || []);

// ✅ list patients
export async function listPatients(params = {}) {
  const { data } = await httpPatients.get("patients/", { params });
  return normalize(data);
}

// ✅ create patient
export async function createPatient(payload) {
  const { data } = await httpPatients.post("patients/", payload);
  return data;
}

// ✅ lookup by UHID
export async function lookupPatientByUhid(uhid) {
  const q = String(uhid || "").trim();
  if (!q) return null;

  try {
    const { data } = await httpPatients.get("patients/", { params: { uhid: q } });
    const list = normalize(data);
    const exact = list.find((p) => String(p?.uhid) === q);
    if (exact) return exact;
    if (list[0]) return list[0];
  } catch (_) {}

  const { data } = await httpPatients.get("patients/", { params: { search: q } });
  const list = normalize(data);
  const exact = list.find((p) => String(p?.uhid) === q);
  return exact || list[0] || null;
}

// ✅ search by phone
export async function searchPatientsByPhone(phone) {
  const q = String(phone || "").trim();
  if (!q) return [];

  const { data } = await httpPatients.get("patients/", {
    params: { search: q },
  });

  return normalize(data);
}

// ✅ get patient by UHID (profile)

export async function getPatientByUhid(uhid) {
  const q = String(uhid || "").trim();
  if (!q) throw new Error("UHID required");

  try {
    const { data } = await httpPatients.get("patients/", { params: { uhid: q } });
    const list = normalize(data);
    const exact = list.find((p) => String(p?.uhid) === q);
    if (exact) return exact;
    if (list[0]) return list[0];
  } catch (_) {}

  const { data } = await httpPatients.get("patients/", { params: { search: q } });
  const list = normalize(data);
  const exact = list.find((p) => String(p?.uhid) === q);
  if (exact) return exact;
  if (list[0]) return list[0];

  throw new Error("Patient not found");
}

